import * as React from 'react';

/**
 * Lightning Icon SVG
 *
 * @returns
 */
function LightningSVG(svgProps: SVGProps) {
	return (
		<svg
			viewBox="0 0 23 32"
			className={'icon icon-lightning ' + svgProps.class}
			focusable="false"
			aria-hidden="true"
		>
			<path d="M13.26 12l2.68-10.279c0.039-0.119 0.061-0.256 0.061-0.399 0-0.728-0.588-1.319-1.315-1.322h-0c-0.002 0-0.005-0-0.007-0-0.409 0-0.773 0.189-1.011 0.485l-0.002 0.003-13.379 17.353c-0.179 0.224-0.287 0.511-0.287 0.823 0 0.001 0 0.002 0 0.003v-0c0.002 0.736 0.598 1.331 1.333 1.334h8.073l-2.68 10.279c-0.038 0.117-0.060 0.252-0.060 0.392 0 0.003 0 0.006 0 0.009v-0c0 0.73 0.592 1.322 1.322 1.322v0c0.002 0 0.005 0 0.007 0 0.409 0 0.773-0.189 1.011-0.485l0.002-0.003 13.372-17.348c0.179-0.224 0.287-0.511 0.287-0.823 0-0.004 0-0.007-0-0.011v0.001c-0.002-0.736-0.598-1.331-1.333-1.334h-8.073z" />
		</svg>
	);
}

LightningSVG.defaultProps = { class: '' };

export default LightningSVG;
